import React from 'react';
import { useTranslation } from 'react-i18next';

import { MetText, NotMetText } from './ContractsRequirements.styled';
import { ContentTitle } from '@/components/agent/dashboard/common';

interface IProps {
  contractsUnmetLength: number;
}

const ContractsRequirementsTitle = ({ contractsUnmetLength }: IProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <ContentTitle>
      {t`dashboard.gigRequirements.textRequirements`}
      {contractsUnmetLength ? (
        <NotMetText>{t('dashboard.gigRequirements.textUnMet', { unmet: contractsUnmetLength })}</NotMetText>
      ) : (
        <MetText>{t`dashboard.gigRequirements.textMet`}</MetText>
      )}
    </ContentTitle>
  );
};

export { ContractsRequirementsTitle };
